export const UPLOAD = {
  REQUEST: 'Attachments/Upload/Request',
  SUCCESS: 'Attachments/Upload/Success',
  FAILURE: 'Attachments/Upload/Failure'
};

export const SET = {
  REQUEST: 'Attachments/Set/Request',
  SUCCESS: 'Attachments/Set/Success',
  FAILURE: 'Attachments/Set/Failure'
};

export const DELETE = {
  REQUEST: 'Attachments/Delete/Request',
  SUCCESS: 'Attachments/Delete/Success',
  FAILURE: 'Attachments/Delete/Failure'
};

export const CLEAR = {
  REQUEST: 'Attachments/Clear/Request',
  SUCCESS: 'Attachments/Clear/Success',
  FAILURE: 'Attachments/Clear/Failure'
};
